import angular from 'angular';
import { MeurhBeneficiosDescontarRescisaoFormController } from './beneficiosdescontar.form.controller';

export class MeurhBeneficiosDescontarRescisaoFormComponent implements angular.IComponentOptions {
    static selector = 'meurhBeneficiosDescontarRescisaoFormComponent';
    static controller = MeurhBeneficiosDescontarRescisaoFormController;
    static template = require('!!html-loader!./beneficiosdescontar.form.html');
    static transclude = true;
    static bindings = {
        entity: '=',
		action: '<',
    };
}
